import Decimal from "decimal.js";
import type { PerspectiveCamera, Scene, WebGLRenderer } from "three";
import type { GameRule } from "whole-shared";

import type { Battlefield } from "./Battlefield";
import type { DiceRoller } from "./DiceRoller";
import type { Engine } from "./Engine";
import type { MatchSimulator } from "./Match";

export const FIELD_SIZE_X = Decimal(29); // these are not official, adjusted to make the png not stretch.
export const FIELD_SIZE_Y = Decimal(22);
export const FIELD_SIZE_X_N = FIELD_SIZE_X.toNumber();
export const FIELD_SIZE_Y_N = FIELD_SIZE_Y.toNumber();

export const fakeRule = { state: { army1p: "nh_sh", army2p: "se_ys", enhancements: [], firstTurn: 0, turn: 0 } } as unknown as GameRule<false>;
export const fakeMatch = { rule: fakeRule } as MatchSimulator;

export let battlefield: Battlefield;
export const setBattlefield = (b: Battlefield) => (battlefield = b);

export let camera: PerspectiveCamera;
export const setCamera = (c: PerspectiveCamera) => (camera = c);

export let diceRoller: DiceRoller;
export const setDiceRoller = (d: DiceRoller) => (diceRoller = d);

export let engine: Engine;
export const setEngine = (e: Engine) => (engine = e);

export let match = fakeMatch;
export const setMatch = (m: MatchSimulator) => (match = m);

export let renderer: WebGLRenderer;
export const setRenderer = (r: WebGLRenderer) => (renderer = r);

export let scene: Scene;
export const setScene = (s: Scene) => (scene = s);

export const detachGlobals = () => {
  battlefield = null as unknown as Battlefield;
  camera = null as unknown as PerspectiveCamera;
  diceRoller = null as unknown as DiceRoller;
  engine = null as unknown as Engine;
  match = fakeMatch;
  renderer = null as unknown as WebGLRenderer;
  scene = null as unknown as Scene;
};
